import Image from 'next/image';

import { staticMediaStoreBaseURL } from '@/config/common';

const HeroSection = () => (
  <section className='relative w-full h-96 md:h-screen overflow-hidden'>
    <div className='absolute inset-0 -z-10'>
      <Image
        alt='Robotic arm and human hand reaching towards each other'
        className='pointer-events-none select-none md:object-center'
        fill
        style={{ objectFit: 'cover', objectPosition: 'left top' }}
        priority
        src={`${staticMediaStoreBaseURL}/about-hafla/hero-section/background.png`}
      />
    </div>

    <div className='relative z-10 flex items-center justify-center h-full px-6 sm:px-8 md:px-12 lg:px-20 text-white'>
      <div className='justify-items-center'>
        <div className='text-center justify-items-center'>
          <div className='font-extrabold font-Montserrat leading-tight text-stroke-thin md:text-stroke-normal'>
            <span className='block md:inline mr-2 text-4xl sm:text-5xl md:text-84px'>
              Hafla:
            </span>
            <span className='block md:inline mt-1 md:mt-0 text-3xl sm:text-4xl md:text-84px'>
              Vertical AI for events
            </span>
          </div>
          <div className='mt-6 font-bold text-xl sm:text-2xl md:text-3xl tracking-tight text-stroke-thin md:text-stroke-normal'>
            Smart. Fast. Awesome.
          </div>
          <div className='mt-6 text-sm sm:text-base md:text-lg max-w-6xl'>
            Hafla is the UAE's leading event-tech company—and the world's first
            true Vertical AI for events. We blend human creativity with AI
            precision to turn complex planning into seamless, joyful
            experiences.
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default HeroSection;
